import { baseValidationTypes } from '@gef-ui/form-core/validations/constants';
import createValidationFn from '@gef-ui/form-core/validations/createValidationFn';
import { getLabelMessage } from '@gef-ui/localization/messages';

import isValidCDV from 'utils/isValidCDV';

export default createValidationFn(
	() => (args) => {
		const { fieldValue } = args;
		if (!fieldValue) {
			return null;
		}

		return isValidCDV(Number(fieldValue)) ? false : getLabelMessage('validation:wrongPSNumber');
	},
	{ type: baseValidationTypes.WARNING },
);
